import React, { useState } from 'react';
import { Box, Tabs, Tab, Paper } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PinCustomerSearch from './PinCustomerSearch';
import PinMonitoringList from './PinMonitoringList';
import PinExchangeDashboard from './PinExchangeDashboard';

const PinExchangeHome = ({ posConfig }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box>
            <Tabs
                value={activeTab}
                onChange={(_, v) => setActiveTab(v)}
                sx={{
                    mb: 2, minHeight: 36,
                    '& .MuiTab-root': {
                        minHeight: 36, py: 0.5, px: 2,
                        textTransform: 'none', fontSize: 13, fontWeight: 600,
                    },
                }}
            >
                <Tab icon={<SearchIcon sx={{ fontSize: 16 }} />} iconPosition="start"
                    label="PIN suchen & verwalten" />
                <Tab icon={<NotificationsActiveIcon sx={{ fontSize: 16 }} />} iconPosition="start"
                    label="Monitoring" />
                <Tab icon={<ListAltIcon sx={{ fontSize: 16 }} />} iconPosition="start"
                    label="Alle PINs" />
            </Tabs>

            <Paper sx={{ p: 4 }}>
                {activeTab === 0 && <PinCustomerSearch posConfig={posConfig} embedded />}
                {activeTab === 1 && <PinMonitoringList posConfig={posConfig} embedded />}
                {activeTab === 2 && <PinExchangeDashboard posConfig={posConfig} embedded />}
            </Paper>
        </Box>
    );
};

export default PinExchangeHome;
